import { useTranslation } from 'react-i18next'

export const useTypeOfBottle = () => {
  const { t } = useTranslation()

  return [
    { name: t('type_of_bottle.lottery.name'), type: 'Lottery', description: t('type_of_bottle.lottery.description') },
    {
      name: t('type_of_bottle.charitable.name'),
      type: 'Charitable',
      description: t('type_of_bottle.charitable.description'),
    },
  ]
}
